import { createContext, useMemo, useEffect, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
import { createEventBus } from '@omni/events';

// src/ShellProvider.tsx
var ShellContext = createContext(null);
function ShellProvider({ value, children }) {
  return /* @__PURE__ */ jsx(ShellContext.Provider, { value, children });
}
var DEFAULT_USER = { id: "standalone", email: "standalone@local" };
var DEFAULT_WORKSPACE = {
  id: "edna",
  label: "Enterprise DNA"
};
function StandaloneShellProvider({
  user = DEFAULT_USER,
  workspace = DEFAULT_WORKSPACE,
  theme = "light",
  signOut,
  children
}) {
  const events = useMemo(
    () => createEventBus({ channel: "omni-standalone" }),
    []
  );
  useEffect(() => () => events.close(), [events]);
  const value = useMemo(
    () => ({
      user,
      workspace,
      theme,
      events,
      navigate: (href) => {
        if (typeof window !== "undefined") window.location.assign(href);
      },
      openContextCard: () => {
      },
      closeContextCard: () => {
      },
      toast: (msg, opts) => {
        console.info("[omni:standalone:toast]", msg, opts ?? "");
      },
      signOut: signOut ?? (() => void 0),
      isStandalone: true,
      // Standalone mode owns the root URL; no prefix to prepend.
      basePath: ""
    }),
    [user, workspace, theme, events, signOut]
  );
  return /* @__PURE__ */ jsx(ShellContext.Provider, { value, children });
}
function useShell() {
  const ctx = useContext(ShellContext);
  if (!ctx) {
    throw new Error(
      "useShell must be used inside <ShellProvider> or <StandaloneShellProvider>"
    );
  }
  return ctx;
}

export { ShellContext, ShellProvider, StandaloneShellProvider, useShell };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map